/* =====================================================================
   VIGILIA — interactions (carrousels, accordeons, packs, CTA)
   Aucune dependance externe. Idempotent : peut etre charge plusieurs fois.
   ===================================================================== */
(function () {
  'use strict';
  if (window.__vigiliaInit) return;
  window.__vigiliaInit = true;

  var GROUP_UNIQUE = '.i5sWDATiPysCtBqNB';
  var GROUP_ABO = '.iBpL58rbeub2no2PO';
  var TOGGLE = '.ibK5hEI51NvSm0myl';

  function all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------------------------------------------------------- carrousels */
  function config(slider) {
    var holder = slider.parentNode;
    var tag = holder && holder.querySelector('script[type="application/json"]');
    if (!tag) tag = slider.querySelector('script[type="application/json"]');
    try { return JSON.parse(tag.textContent); } catch (e) { return null; }
  }

  function bp(cfg) {
    if (!cfg || !cfg.breakpoints) return { slidesPerView: 1, spaceBetween: 0 };
    var w = window.innerWidth, best = null, bestKey = -1;
    Object.keys(cfg.breakpoints).forEach(function (k) {
      var n = parseInt(k, 10);
      if (w >= n && n > bestKey) { bestKey = n; best = cfg.breakpoints[k]; }
    });
    return best || cfg.breakpoints[Object.keys(cfg.breakpoints)[0]];
  }

  function layout(slider) {
    var wrap = slider.querySelector(':scope > .instant-slider-wrapper');
    if (!wrap) return;
    var cfg = config(slider), o = bp(cfg);
    var per = o.slidesPerView || 1, gap = o.spaceBetween || 0;
    var slides = all(':scope > .instant-slider-slide', wrap);
    if (!slides.length) return;

    wrap.style.overflowX = 'auto';
    wrap.style.scrollSnapType = 'x mandatory';
    wrap.style.scrollBehavior = 'smooth';
    wrap.style.gap = gap + 'px';
    wrap.style.scrollbarWidth = 'none';
    wrap.style.msOverflowStyle = 'none';
    if (!wrap.__vigScrollbar) {
      wrap.__vigScrollbar = true;
      var st = document.createElement('style');
      st.textContent = '.vigilia-page .instant-slider-wrapper::-webkit-scrollbar{display:none}';
      document.head.appendChild(st);
    }
    slides.forEach(function (sl) {
      sl.style.width = '';
      sl.style.marginRight = '';
      sl.style.flex = '0 0 calc((100% - ' + (gap * (per - 1)) + 'px) / ' + per + ')';
      sl.style.scrollSnapAlign = per === 1 ? 'center' : 'start';
    });
    slider.__vig = { wrap: wrap, slides: slides, per: per };
  }

  function index(state) {
    var w = state.wrap, mid = w.scrollLeft + w.clientWidth / 2, best = 0, dist = Infinity;
    state.slides.forEach(function (sl, i) {
      var c = sl.offsetLeft + sl.offsetWidth / 2 - w.offsetLeft;
      var d = Math.abs(c - mid);
      if (d < dist) { dist = d; best = i; }
    });
    return best;
  }

  function goTo(state, i) {
    i = Math.max(0, Math.min(state.slides.length - 1, i));
    var sl = state.slides[i];
    state.wrap.scrollTo({ left: sl.offsetLeft - state.wrap.offsetLeft, behavior: 'smooth' });
  }

  function initSliders(root) {
    all('.instant-slider', root).forEach(function (slider) {
      if (slider.__vigDone) return;
      slider.__vigDone = true;
      layout(slider);
      window.addEventListener('resize', function () { layout(slider); });

      var id = slider.getAttribute('data-instant-slider-id');
      var holder = slider.closest('.instant-slider-container') || slider.parentNode;
      var scope = holder.parentNode || document;

      // fleches
      if (id) {
        all('.instant-slider-' + id + '-button-next', scope).forEach(function (b) {
          b.addEventListener('click', function () { if (slider.__vig) goTo(slider.__vig, index(slider.__vig) + 1); });
        });
        all('.instant-slider-' + id + '-button-prev', scope).forEach(function (b) {
          b.addEventListener('click', function () { if (slider.__vig) goTo(slider.__vig, index(slider.__vig) - 1); });
        });
      }

      // pagination
      var cfg = config(slider);
      if (cfg && cfg.pagination && cfg.pagination.el) {
        var pag = document.querySelector(cfg.pagination.el);
        if (pag && slider.__vig) {
          pag.innerHTML = '';
          slider.__vig.slides.forEach(function (_, i) {
            var b = document.createElement('span');
            b.className = 'instant-slider-pagination-bullet' + (i === 0 ? ' instant-slider-pagination-bullet-active' : '');
            b.addEventListener('click', function () { goTo(slider.__vig, i); });
            pag.appendChild(b);
          });
          slider.__vigPag = pag;
        }
      }
    });

    // vignettes <-> carrousel principal
    all('.instant-slider-thumbs', root).forEach(function (th) {
      if (th.__vigLinked) return;
      th.__vigLinked = true;
      var id = th.getAttribute('data-instant-slider-id');
      var main = document.querySelector('.instant-slider[data-instant-slider-id="' + id + '"]:not(.instant-slider-thumbs)');
      if (!main || !main.__vig || !th.__vig) return;

      th.__vig.slides.forEach(function (sl, i) {
        sl.addEventListener('click', function () { goTo(main.__vig, i); });
      });
      var sync = function () {
        var i = index(main.__vig);
        th.__vig.slides.forEach(function (sl, k) {
          sl.classList.toggle('instant-slider-thumb-active', k === i);
          sl.classList.toggle('instant-slider-slide-active', k === i);
        });
        if (main.__vigPag) {
          Array.prototype.forEach.call(main.__vigPag.children, function (b, k) {
            b.classList.toggle('instant-slider-pagination-bullet-active', k === i);
          });
        }
      };
      main.__vig.wrap.addEventListener('scroll', function () {
        clearTimeout(main.__vigT);
        main.__vigT = setTimeout(sync, 60);
      });
      sync();
    });

    // pagination seule (logos presse)
    all('.instant-slider', root).forEach(function (sl) {
      if (!sl.__vigPag || sl.__vigPagBound) return;
      sl.__vigPagBound = true;
      sl.__vig.wrap.addEventListener('scroll', function () {
        clearTimeout(sl.__vigPT);
        sl.__vigPT = setTimeout(function () {
          var i = index(sl.__vig);
          Array.prototype.forEach.call(sl.__vigPag.children, function (b, k) {
            b.classList.toggle('instant-slider-pagination-bullet-active', k === i);
          });
        }, 60);
      });
    });
  }

  /* ---------------------------------------------------------- accordeons */
  var PLUS = 'M224,128a8,8,0,0,1-8,8H136v80a8,8,0,0,1-16,0V136H40a8,8,0,0,1,0-16h80V40a8,8,0,0,1,16,0v80h80A8,8,0,0,1,224,128Z';
  var MINUS = 'M224,128a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128Z';

  function initAccordions(root) {
    all('[data-instant-type="accordion-item"]', root).forEach(function (item) {
      if (item.__vigDone) return;
      item.__vigDone = true;
      var head = item.querySelector('[data-instant-type="accordion-header"]');
      var body = item.querySelector('[data-instant-type="accordion-content"]');
      if (!head || !body) return;
      body.style.overflow = 'hidden';
      body.style.height = '0px';
      item.setAttribute('data-state', 'closed');
      head.setAttribute('aria-expanded', 'false');

      head.addEventListener('click', function () {
        var open = item.getAttribute('data-state') === 'open';
        item.setAttribute('data-state', open ? 'closed' : 'open');
        head.setAttribute('aria-expanded', open ? 'false' : 'true');
        body.style.height = open ? '0px' : body.scrollHeight + 'px';
        var p = head.querySelector('svg path');
        if (p) p.setAttribute('d', open ? PLUS : MINUS);
        if (!open) {
          setTimeout(function () {
            if (item.getAttribute('data-state') === 'open') body.style.height = 'auto';
          }, 200);
        }
      });
      window.addEventListener('resize', function () {
        if (item.getAttribute('data-state') === 'open') body.style.height = 'auto';
      });
    });
  }

  /* -------------------------------------------------------------- packs */
  function initPacks(root) {
    all('[data-instant-action-type="select-variant-option"]', root).forEach(function (card) {
      if (card.__vigDone) return;
      card.__vigDone = true;
      // uniquement les vraies cartes d'un groupe de packs (le bloc prix n'en est pas un)
      var siblings = card.parentNode.querySelectorAll(':scope > [data-instant-action-type="select-variant-option"]');
      if (siblings.length < 2) return;
      card.style.cursor = 'pointer';
      card.setAttribute('role', 'button');
      card.setAttribute('tabindex', '0');
      var pick = function () {
        var group = card.parentNode;
        all('[data-instant-action-type="select-variant-option"]', group).forEach(function (c) {
          c.setAttribute('data-instant-state', c === card ? 'active' : 'inactive');
        });
        var input = document.querySelector('.vigilia-page [name="vigilia-offer"]');
        if (input) input.value = card.getAttribute('data-instant-option-value') || '';
      };
      card.addEventListener('click', pick);
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(); }
      });
    });
  }

  /* ------------------------------------------------- bascule abonnement */
  function initToggle(root) {
    var toggle = (root || document).querySelector(TOGGLE);
    var uniq = (root || document).querySelector(GROUP_UNIQUE);
    var abo = (root || document).querySelector(GROUP_ABO);
    if (!toggle || !uniq || !abo || toggle.__vigDone) return;
    toggle.__vigDone = true;

    abo.style.display = 'none';
    var box = toggle.querySelector('.idjHCewFq1yVA7b7S');
    var mark = toggle.querySelector('.ieZNc3yqlR2nF2jvp');
    if (mark) mark.style.visibility = 'hidden';
    toggle.style.cursor = 'pointer';
    toggle.setAttribute('role', 'checkbox');
    toggle.setAttribute('aria-checked', 'false');

    toggle.addEventListener('click', function () {
      var on = toggle.getAttribute('aria-checked') === 'true';
      toggle.setAttribute('aria-checked', on ? 'false' : 'true');
      if (mark) mark.style.visibility = on ? 'hidden' : 'visible';
      abo.style.display = on ? 'none' : 'flex';
      uniq.style.display = on ? 'flex' : 'none';
      if (box) box.style.opacity = on ? '' : '1';
    });
  }

  /* ------------------------------------- CTA -> selecteur de quantite */

  // Le selecteur de quantite de la section produit native (main-product).
  // On lui pose un id stable pour que les boutons puissent y pointer.
  var QTY_SELECTORS = [
    '.quantity-breaks-container',
    '.product-form__quantity',
    'quantity-input',
    '.product-form__buttons'
  ];

  function qtyTarget() {
    for (var i = 0; i < QTY_SELECTORS.length; i++) {
      var el = document.querySelector(QTY_SELECTORS[i]);
      if (el) return el;
    }
    return document.getElementById('vigilia-packs');
  }

  function tagTargets() {
    var t = qtyTarget();
    if (t && !document.getElementById('vigilia-quantite')) t.id = 'vigilia-quantite';
  }

  // Defilement anime maison : scrollIntoView({behavior:'smooth'}) est ignore
  // dans certains contextes (iframe, compositeur inactif, reduced-motion).
  function animateTo(top, done) {
    top = Math.max(0, Math.round(top));
    var start = window.pageYOffset || document.documentElement.scrollTop;
    var delta = top - start;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || Math.abs(delta) < 2) { window.scrollTo(0, top); if (done) done(); return; }

    var dur = Math.min(900, Math.max(300, Math.abs(delta) / 4)), t0 = null, finished = false;
    function end() {
      if (finished) return;
      finished = true;
      window.scrollTo(0, top);
      if (done) done();
    }
    function step(ts) {
      if (finished) return;
      if (t0 === null) t0 = ts;
      var p = Math.min(1, (ts - t0) / dur);
      var e = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
      window.scrollTo(0, start + delta * e);
      if (p < 1) requestAnimationFrame(step); else end();
    }
    if (window.requestAnimationFrame) requestAnimationFrame(step); else end();
    // filet de securite : si rAF ne tourne pas, on se positionne quand meme
    setTimeout(end, dur + 300);
  }

  function scrollTo(t) {
    if (!t) return;
    var rect = t.getBoundingClientRect();
    var pageTop = rect.top + (window.pageYOffset || document.documentElement.scrollTop);
    var top = rect.height < window.innerHeight
      ? pageTop - (window.innerHeight - rect.height) / 2   // centre si ca tient
      : pageTop - 20;                                      // sinon, aligne en haut
    t.style.transition = 'box-shadow .4s ease';
    t.style.boxShadow = '0 0 0 3px rgba(18,94,73,.45)';
    setTimeout(function () { t.style.boxShadow = ''; }, 1600);
    animateTo(top, function () {
      // focus clavier une fois le defilement termine (sinon il l'annule)
      var first = t.querySelector('input[name="quantity"], select, button');
      if (first && first.focus) { try { first.focus({ preventScroll: true }); } catch (e) {} }
    });
  }

  function initCta(root) {
    tagTargets();
    all('a[href^="#"]', root).forEach(function (a) {
      if (a.__vigDone) return;
      a.__vigDone = true;
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('href').slice(1);
        if (!id) return;
        tagTargets();
        var t = document.getElementById(id);
        // le selecteur de quantite prime : si la cible manque, on y retombe
        if (!t && id !== 'vigilia-avis') t = qtyTarget();
        if (!t) return;
        e.preventDefault();
        scrollTo(t);
      });
    });
  }

  function boot() {
    all('.vigilia-page').forEach(function (root) {
      initSliders(root);
      initAccordions(root);
      initPacks(root);
      initToggle(root);
      initCta(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // editeur de theme Shopify
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:select', boot);
})();
